export default "__VITE_ASSET__BVmWSV4T__"